import { BrowserOptions } from '@sentry/browser';

import { loadFiles } from './loader';

import { B3window } from './b3checkout/config'

export interface CustomCheckoutWindow extends Window {
    checkoutConfig: {
        containerId: string;
        orderId?: number;
        checkoutId?: string;
        publicPath?: string;
        sentryConfig?: BrowserOptions;
    };
}

function isCustomCheckoutWindow(window: Window): window is CustomCheckoutWindow {
    const customCheckoutWindow: CustomCheckoutWindow = window as CustomCheckoutWindow;

    return !!customCheckoutWindow.checkoutConfig;
}

const detectB3Config = (render: Function) => {
    let count = 0
    const timer = setInterval(() => {
        if (count > 4) clearInterval(timer)
        if ((window as B3window).b3CheckoutConfig) {
            render()
            clearInterval(timer)
        }
        count++
    }, 500)
}

(async function autoLoad() {
    if (!isCustomCheckoutWindow(window)) {
        throw new Error('Checkout config is missing.');
    }

    const {
        renderOrderConfirmation,
        renderCheckout,
    } = await loadFiles();

    const {
        orderId,
        checkoutId,
        ...appProps
    } = window.checkoutConfig;

    if (orderId) {
        renderOrderConfirmation({ ...appProps, orderId });
    } else if (checkoutId) {
        renderCheckout({ ...appProps, checkoutId });
        detectB3Config(() => renderCheckout({ ...appProps, checkoutId }))
    }
})();
